import { AdvocateStoryOverviewMeta, AdvocateStoryOverviewPayload } from 'types/store/AdvocateStoryOverview';
import { createAsyncReducer } from 'utils/Redux';

import { advocateStoryOverviewActions } from '../actions';

export default createAsyncReducer<AdvocateStoryOverviewMeta, AdvocateStoryOverviewPayload>(advocateStoryOverviewActions);
